import { useQuery } from '@tanstack/react-query';

import { courseConst } from 'modules/courses';
import { $apiV2 } from 'modules/global';

import { ITeacherTests } from '..';

export const getTeacherTests = (id?: number) => async () => {
  const { data } = await $apiV2.get(`/teacher/teacher-tests/${id}`);

  return { teacherTests: data?.data };
};

export const useTeacherTests = (id?: number) => {
  const { data, ...args } = useQuery<{ teacherTests: ITeacherTests[] }>({
    queryKey: [courseConst.queryKeys.TEACHER_TESTS, id],
    queryFn: getTeacherTests(id)
  });

  return { ...data, ...args };
};
